import React, { memo } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
    Label,
    Form,
    FormGroup,
    Row,
} from 'reactstrap';
import IntlMessages from '../../../helpers/IntlMessages';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AddCommaNumber } from '../../../helpers/Utils';
import Creatable from '../../../components/common/CreatableSelect';
import { Colxx } from '../../../components/common/CustomBootstrap';

const ContentComponent = ({
    title,
    isOpen,
    toggle,
    onSubmit,
    values,
    setting,
    onChange,
    onChangePrice,
    data_stocks,
}) => {
    // console.log('render AddComponent');

    let items_select = [];
    items_select = data_stocks.map(item => ({
        label: item.name, // Hiển thị tên sản phẩm cho người dùng
        value: item.name, // Giá trị khi chọn cũng là tên sản phẩm
        // ...item           // Thêm tất cả các thuộc tính khác của item vào option
    }));
    if (values?.log?.length > 0) {
        const reducer = (a, o) => (
            a.push({
                label: o.name,
                value: o.id,
            }),
            a
        );
        items_select = values?.log
            ?.filter((_item) => _item.alias === 'new')
            .reduce(reducer, []);
    }

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            wrapClassName='modal-right'
            backdrop={true}
        >
            <Form onSubmit={(e) => onSubmit(e)}>
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody className='scrool modal-right-add'>
                    <PerfectScrollbar
                        options={{
                            suppressScrollX: true,
                            wheelPropagation: false,
                        }}
                        id='modal-right__body'
                    >
                        <FormGroup className='mt-3 has-float-label'>
                            <Label for='item_name' className='text-muted'>
                                <IntlMessages id='company-provider.item_name' /><span style={{color: 'red'}}>*</span>
                            </Label>
                            <Creatable
                                className={'react-select-creatable'}
                                placeholder={'Chọn hoặc tạo mới mặt hàng cung cấp'}
                                name='items_selected'
                                id='items_selected'
                                onChange={(val) =>
                                    onChange(val, 'items_selected')
                                }
                                value={values.items_selected}
                                options={items_select}
                                formatCreateLabel={(inputValue) => `Tạo mới mặt hàng: "${inputValue}"`}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999 // Đảm bảo portal menu luôn ở trên cùng
                                    })
                                }}
                            />
                        </FormGroup>
                        {values.items_selected?.__isNew__ && (
                            <FormGroup className='has-float-label'>
                                <Label for='new_item_unit' className='text-muted'>
                                    Đơn vị tính <span style={{ color: 'red' }}>*</span>
                                </Label>
                                <Input
                                    name='new_item_unit' // Tên cho state
                                    id='new_item_unit'
                                    placeholder='Ví dụ: Cái, Bộ, Hộp'
                                    value={values.new_item_unit || ''} // Lấy giá trị từ state
                                    onChange={onChange} // Dùng hàm onChange chung
                                />
                            </FormGroup>
                        )}
                        <Row>
                            <Colxx xxs='6'>
                                <FormGroup className='has-float-label'>
                                    <Label for='price' className='text-muted'>
                                        <IntlMessages id='company-provider.price_new' /><span style={{color: 'red'}}>*</span>
                                    </Label>
                                    <Input
                                        type='text'
                                        name='price'
                                        id='price'
                                        value={AddCommaNumber(values.price)}
                                        onChange={onChange}
                                        />
                                </FormGroup>
                            </Colxx>
                            <Colxx xxs='6'>
                                <FormGroup className='has-float-label'>
                                    <Label for='quantity' className='text-muted'>
                                        <IntlMessages id='company-provider.quantity' /><span style={{color: 'red'}}>*</span>
                                    </Label>
                                    <Input
                                        type='number'
                                        name='quantity'
                                        id='quantity'
                                        value={values.quantity}
                                        onChange={onChange}
                                        />
                                </FormGroup>
                            </Colxx>
                        </Row>
                        <FormGroup className='has-float-label'>
                            <Label for='price_outcome' className='text-muted'>
                                <IntlMessages id='company-provider.total_price_outcome' /><span style={{color: 'red'}}>*</span>
                            </Label>
                            <Input
                                name='price_outcome'
                                id='price_outcome'
                                placeholder='0'
                                value={AddCommaNumber(values.price_outcome)}
                                onChange={onChangePrice}
                            />
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='price_income' className='text-muted'>
                                <IntlMessages id='company-provider.total_price_income' />
                            </Label>
                            <Input
                                disabled
                                name='price_income'
                                id='price_income'
                                placeholder='0'
                                value={AddCommaNumber(Number((values.price || "0").toString().replace(/\./g, '')) * Number(values.quantity) || 0)}
                                onChange={onChangePrice}
                            />
                        </FormGroup>
                        <FormGroup className='has-float-label'>
                            <Label for='price_pending' className='text-muted'>
                                <IntlMessages id='company-provider.total_price_pending' />
                            </Label>
                            <Input
                                type='text'
                                name='price_pending'
                                id='price_pending'
                                placeholder='0'
                                disabled={true}
                                value={AddCommaNumber(values.price_pending)}
                            />
                        </FormGroup>
                    </PerfectScrollbar>
                </ModalBody>
                <ModalFooter>
                    <Button color='primary'>
                        <IntlMessages id='general.btn-add' />
                    </Button>{' '}
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default memo(ContentComponent);
